import { disallow } from 'feathers-hooks-common';
import { withSearch } from 'src/feathers/hooks';

const withSearches = withSearch({
  '$shipment.carrier.name$': withSearch.string,
  '$shipment.pickup_address.city$': withSearch.string,
  '$shipment.pickup_address.name$': withSearch.string,
  '$shipment.delivery_address.city$': withSearch.string,
  '$shipment.delivery_address.name$': withSearch.string,
  '$shipment.reference_number$': withSearch.text,
  '$shipment.id$': withSearch.number,
  id: withSearch.number
});

export default {
  before: {
    all: [],
    find: [withSearches],
    get: [disallow()],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
